import VueRecaptcha from 'vue-recaptcha';
import { required, email } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import hash from 'object-hash';

import config from '@/config';
import api from '@/services/api';
import gaMixin from '@/shared/mixins/ga';

const STORAGE_KEY = 'tour_unlocked';

export default {
  name: 'HMTLeadCapture',
  mixins: [
    gaMixin
  ],
  components: {
    VueRecaptcha
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      token: null,
      submitting: false,
      enabled: false,
      siteKey: config.RECAPTCHA_SITE_KEY
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required
    },
    token: {
      required
    }
  },
  computed: {
    ...mapGetters('tour', ['getId', 'getLeadCapture'])
  },
  methods: {
    ...mapActions('leadCapture', ['leadcapture']),
    initRecaptcha() {
      let script = document.createElement('script');
      script.src = config.RECAPTCHA_URL;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    },
    onVerify(response) {
      this.token = response
    },
    onExpired() {
      this.token = null
    },
    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.submitting = true;

      const payload = {
        tourId: this.getId,
        name: this.name,
        email: this.email,
        phone: this.phone
      };

      api.leadCapture.send(payload)
        .then(res => {
          this.submitting = false;

          if (res.status === 'success') {
            this.unLockTour();
            this.sendEventGA('Lead capture', 'Send Form', 'Sent');
          } else {
            this.notifyError();
          }
        })
        .catch(error => {
          console.log({error});

          this.submitting = false;

          this.notifyError();
        });
    },
    notifyError () {
      this.$notify({
        group: 'form',
        type: 'error',
        title: this.$t('notifications.errorTitle'),
        text: this.$t('notifications.genericError')
      });
    },
    hashTour () {
      return hash({ id: `MU${this.getId}ML` });
    },
    lockTour () {
      this.enabled = true;
      this.lockScroll();
      this.initRecaptcha();
    },
    unLockTour () {
      this.unlockScroll();
      this.enabled = false;
      localStorage.setItem(STORAGE_KEY , this.hashTour());
    },
    lockScroll () {
      document.querySelector('html').classList.add('scroll-hidden');
    },
    unlockScroll () {
      document.querySelector('html').classList.remove('scroll-hidden');
    },
    close () {
      this.unLockTour();
    }
  },
  mounted () {
    if (!localStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY) !== this.hashTour()) {
      this.lockTour();
    }
  }
}
